import {AppLocale, isAppLocale} from './config'
import type {LocalesManifest} from './messageManifest'

function localesBaseUrl(): string {
  const publicUrl = (process.env.PUBLIC_URL ?? '').replace(/\/$/, '')
  return publicUrl ? `${publicUrl}/locales` : '/locales'
}

function cacheVersion(manifest?: LocalesManifest): string {
  return (
    manifest?.version ??
    process.env.REACT_APP_I18N_CACHE_VERSION ??
    process.env.REACT_APP_VERSION ??
    'dev'
  )
}

async function fetchJson<T>(url: string): Promise<T> {
  const response = await fetch(url, {cache: 'no-cache'})
  if (!response.ok) {
    throw new Error(`HTTP ${response.status} for ${url}`)
  }
  return response.json() as Promise<T>
}

export async function fetchAppMessages(locale: string): Promise<Record<string, string>> {
  const appLocale: AppLocale = isAppLocale(locale) ? locale : 'id'
  const base = localesBaseUrl()

  const manifest = await fetchJson<LocalesManifest>(`${base}/manifest.json`)
  const v = encodeURIComponent(cacheVersion(manifest))
  const modules = manifest.modules ?? []

  if (modules.length === 0) {
    throw new Error('locales manifest has no modules')
  }

  const chunks = await Promise.all(
    modules.map((module) =>
      fetchJson<Record<string, string>>(`${base}/${appLocale}/${module}.json?v=${v}`)
    )
  )

  return Object.assign({}, ...chunks)
}
